import type { RBACGroup } from '../../../types';
import { useQueryErrorToast } from '../../graph/hooks/useQueryErrorToast';
import { useGetGroupOwnersQuery } from '../../graph/services/graphApi';

import UserListPanel from './UserListPanel';

type Props = {
  role: RBACGroup;
};

// Who administers the role group. Graph only allows users as owners, so the add
// autocomplete is users-only. Same staging behaviour as the Members panel — both
// are thin wrappers over UserListPanel, differing only in query, bucket, and labels.
export default function OwnersPanel({ role }: Props) {
  const { data: owners, isError } = useGetGroupOwnersQuery(role.id);
  useQueryErrorToast(isError, 'Failed to load owners');

  return (
    <UserListPanel
      bucket="owners"
      title="Owners"
      placeholder="Add an owner"
      emptyLabel="No owners."
      items={owners}
    />
  );
}
